export const namespaced = true
import {NotificationEB} from '../EventBus/NotificationEB'
export const state= {
    mtodMessage: null
}
export const mutations ={
    SET_MOTD(state, payload){
        // console.log("SET_MOTD : ",payload)
        state.mtodMessage = payload
        NotificationEB.$emit("newNotification",  state.mtodMessage)
    }
}
export const actions = {
    async requestMotd(context,payload){

        let connectionStatus = context.rootGetters['connection/getConnectionStatus']
            if(connectionStatus){

                let socket = context.rootGetters['connection/getConnection'] 
                socket.emit("motdRequest",payload)
                socket.on("motdData" ,(data)=>{
                    context.commit("SET_MOTD", data)    
                   
                })
            }
    }
}
export const getters = {
    getMotd:(state)=>{
        return state.mtodMessage
    }
}